'use client';

import { createContext, useMemo, useContext, ReactNode, ReactElement } from 'react';

import getHTTP, { HttpInstance } from 'src/utils/http-client';

export type HttpContextProviderProps = {
  children: ReactNode;
  config: {
    gatewayAddress: string;
    csrfTokenHashName: string;
    csrfTokenHashValue: string;
    apiConnectionTimeout: number;
  };
};

const HttpContext = createContext<HttpInstance>(getHTTP({ gatewayAddress: '/' }));

export function HttpContextProvider({ children, config }: HttpContextProviderProps): ReactElement {
  const { gatewayAddress, csrfTokenHashValue, csrfTokenHashName, apiConnectionTimeout } = config;
  const http = useMemo(
    () =>
      getHTTP({
        gatewayAddress,
        apiConnectionTimeout,
        requestHeaders: { [csrfTokenHashName]: csrfTokenHashValue },
      }),
    [gatewayAddress, csrfTokenHashValue, csrfTokenHashName, apiConnectionTimeout],
  );

  return <HttpContext.Provider value={http}>{children}</HttpContext.Provider>;
}

export default function useHttp(): HttpInstance {
  return useContext(HttpContext);
}
